export default __webpack_public_path__ + "static/media/Performance.b987e967.svg";